<div class="ziti-page-container lt-skin-page">
  <lib-list-table-header
    title="OIDC Organization to Public Client Map"
    subtitle="The OIDC public clients that are mapped to this organization"
    createLabel="Create OIDC Organization to Public Client Map"
    infoText="This map links an OIDC public client to this organization so its users can sign in to it."
    [tabs]="tabs"
    [showAdd]="false"
    [blockDelete]="true"
  >
    <span header-icon class="icon-CAs" aria-hidden="true"></span>
  </lib-list-table-header>

  <div class="oidc-org-public-client-map-panel-row" [class.is-split]="!!list.selected">
    <div class="oidc-org-public-client-map-list-panel">
      <lib-list-table
        class="lt-skin"
        [tableId]="tableId"
        [initialPageSize]="initialPageSize"
        [options]="tableOptions"
        [columns]="listColumns"
        [rowData]="list.rows"
        [isLoading]="isLoading"
        [hasNext]="list.hasNext"
        [hasPrev]="list.hasPrev"
        [startCount]="list.startCount"
        [endCount]="list.endCount"
        [totalCount]="list.totalCount"
        [filterApplied]="list.filterApplied"
        [filterColumn]="searchFilter"
        [accessDenied]="accessDenied"
        filterName="Name"
        entityTypeName="OIDC organization to public client maps"
        noItemsImage="nodata"
        [showNoItemsAdd]="false"
        [noItemsReadonly]="true"
      ></lib-list-table>
    </div>

    @if (list.selected; as map) {
      <app-detail-drawer
        eyebrow="OIDC Organization to Public Client Map Detail"
        [title]="map.name || map.id"
        [index]="list.selectedIndex"
        [total]="list.rows.length"
        (closed)="list.close()"
        (navigated)="list.step($event)"
      >
        <app-record-detail [sections]="detailSections(map)"></app-record-detail>
      </app-detail-drawer>
    }
  </div>
</div>
